import React from 'react';
import SignInForm from './SignInForm';
import { Link } from 'react-router-dom';

const SignInPage: React.FC = () => {
  return (
    <div className="w-full h-screen relative bg-[#f7f9fd] overflow-hidden">
      {/* Header */}
      <div className="w-full h-20 bg-white shadow-[0px_4px_4px_0px_rgba(0,0,0,0.01)]">
        <div className="max-w-[1920px] mx-auto px-4 h-full relative flex items-center">
          <Link to="/" className="md:block hidden">
            <div className="w-auto h-8 left-[40px] top-[26px] absolute whitespace-nowrap text-[#1A253F] text-[14px] md:text-[28px] font-extrabold font-pretendard leading-9">
              부산항신항시설관리센터
            </div>
          </Link>
          {/* Mobile Header */}
          <Link to="/" className="md:hidden block w-full">
            <div className="w-full h-7 text-center text-[#1A253F] text-[18px] md:text-[28px] font-extrabold font-pretendard leading-9">
              부산항신항시설관리센터
            </div>
          </Link>
        </div>
      </div>
      <div className="w-full h-px bg-white border border-slate-200"></div>

      {/* Background with gradient overlay */}
      <div className="w-full h-[calc(100%-80px)] left-0 top-[80px] absolute bg-[#082145] backdrop-blur-[0px] z-10"></div>
      <div className="w-full h-[calc(100%-80px)] left-0 top-[80px] absolute overflow-hidden z-10">
        <img 
          className="w-full h-full object-cover md:block hidden" 
          src="/images/sign-banner.jpg" 
          alt="background"
        />
        <img 
          className="w-full h-full object-cover md:hidden block" 
          src="/images/sign-banner.jpg" 
          alt="background"
        />
      </div>
      <div className="w-full h-[calc(100%-80px)] left-0 top-[80px] absolute bg-gradient-to-l from-[#082145]/50 to-[#082246]/25 backdrop-blur-[0px] z-10"></div>

      {/* Login Container */}
      <div className="max-w-[1920px] mx-auto px-4 h-full relative z-20">
        <div className="w-[calc(100%-40px)] md:w-[688px] h-[490px] md:h-[600px] left-1/2 top-[120px] md:top-[148px] -translate-x-1/2 absolute bg-white rounded-sm outline outline-1 outline-slate-200">
          <div className="w-64 h-11 md:h-11 h-7 left-[40px] md:left-[74px] top-[42px] md:top-[55px] top-[42px] absolute justify-center text-slate-800 text-4xl md:text-4xl text-xl font-extrabold font-['Pretendard'] leading-9">
            로그인
          </div>
          <div className="w-[calc(100%-80px)] md:w-[540px] h-auto md:h-7 left-[40px] md:left-[74px] top-[84px] md:top-[96px] top-[84px] absolute justify-center text-slate-700 text-xl md:text-xl text-xs font-normal font-['Pretendard'] leading-8 md:leading-9">
            <div className="md:whitespace-nowrap space-y-2 md:space-y-0">
              부산항신항시설관리센터에 오신 것을 환영합니다
            </div>
          </div>
          <div className="w-[calc(100%-80px)] md:w-[540px] h-0 left-[40px] md:left-[74px] top-[130px] md:top-[155px] top-[130px] absolute outline outline-1 outline-offset-[-0.50px] outline-neutral-200"></div>
          <SignInForm />
        </div>
      </div>
    </div>
  );
};

export default SignInPage; 